export function LightHorizontalContainer({ children, className = "" }) {

    return (
        <div className={`d-flex mb-2 gap-3 overflow-auto bg-light rounded-3 ps-2 pe-2 align-items-center justify-content-around ${className}`}>
            {children}
        </div>
    );
}